<template>
  <section class="error-container">
    <div
      class="error-img">
      <img
        src="~@/assets/img/error.svg"
        alt="error">
      <div class="error-code">
        <h4>405</h4>
        <h6>ERROR</h6>
      </div>
    </div>
    <h1 class="error-title">Whoops!</h1>
    <p class="error-description">
      The server encountered a temporary error and could not complete your request. Please try again in 1 minute.
    </p>
    <router-link
      :to="{ name: 'FrontPage' }"
      class="btn btn-main btn-round">
      Home
    </router-link>
  </section>
</template>

<script>
export default {
  name: 'NotAllowed',
};
</script>
